import { SVGProps } from 'react';

export const IconInfo = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 14 14'>
      <g fill='none' fillRule='evenodd'>
        <path d='M13 7A6 6 0 111 7a6 6 0 0112 0z' stroke='currentColor' />
        <path d='M7.522 4.391a.522.522 0 11-1.043 0 .522.522 0 011.043 0' fill='currentColor' />
        <path stroke='currentColor' strokeWidth='1.3' d='M7 9.87V6.217H5.957' />
      </g>
    </svg>
  );
};
